import { useEffect, useRef } from "react";
import Board from "../../chessBoard/components/Board";
import { Chess } from "@chesshotel/chesslib";
import { convertMoves } from "../../util/moves";
import { useState } from "react";
import { ChessSets } from "@chesshotel/constants";

const settings = { chessSet: ChessSets.STAUNTY };

export default function FreeTurnBoard(props) {
  const size = props.size || 504;
  const [playingWhite, setPlayingWhite] = useState(false);
  const [possibleMoves, setPossibleMoves] = useState({});
  const [fen, setFen] = useState(null);
  const [animate, setAnimate] = useState(false);

  const chess = useRef(Chess()).current;

  useEffect(() => {
    const valid = props.fen && chess.load(props.fen, 1);

    if (!valid) {
      return;
    }
    setPlayingWhite(chess.turn() === "w");

    const possibleMoves = convertMoves(chess.moves({ verbose: true }));

    setPossibleMoves(possibleMoves);

    setAnimate(true);
    setFen(props.fen);
  }, [props.fen]);

  function moveMade(move) {
    const piece = chess.remove(move.from);
    chess.put(piece, move.to);

    const possibleMoves = convertMoves(chess.moves({ verbose: true }));
    setPossibleMoves(possibleMoves);
    setFen(fen);
  }

  return (
    <div className="flex justify-start w-full py-8 overflow-x-visible">
      <div className="flex">
        <Board
          settings={settings}
          fen={fen}
          animate={animate}
          size={size}
          playingWhite={playingWhite}
          possibleMoves={possibleMoves}
          onMoveMade={(move) => moveMade(move)}
        />
      </div>
    </div>
  );
}
